import { getPromoMessaging } from "../../utils/product/getPromoMessaging";
import styles from "./PromotionalMessages.module.scss";
import { PRODUCT_SPECIAL_OFFERS_ACCORDION_INSTANCE_NAME } from "../ProductAccordion/components/ProductSpecialOffersAccordion/ProductSpecialOffersAccordionUI";
import {
  NonPromotionalMessage,
  PromotionalMessage,
} from "../../types/prodcatBaseTypes";
import { PromotionalCountdownTimer } from "./PromotionalCountdownTimer/PromotionalCountdownTimer";

type CountDownTimerDate = {
  year: number;
  month: number;
  day: number;
};

type Props = {
  /**
   * An array of Message objects.
   */
  promotionalMessages: (PromotionalMessage | NonPromotionalMessage)[];

  /**
   * Flag to show Promotional messages on page and not drawer.
   */
  hidePromoDrawer: boolean;

  /**
   * String to show which Promotional message timer variant (A/B/C).
   */
  showPromoTimerVariant: string;

  /**
   * Flag to determine if product in countdown test is available to order.
   */
  countdownTimerAvailabileToOrder: boolean;

  /**
   * Array of year, month and date as integers.
   */
  countdownTimerEnd: CountDownTimerDate;
};

const MAX_PROMO_MESSAGES = 2;

function dispatchAccordionOpenEvent(target: string) {
  const event = new CustomEvent(`jlds:accordion:${target}`, {
    detail: { action: "open" },
  });
  document.body.dispatchEvent(event);
}

export const PromotionalMessagesUI = ({
  promotionalMessages,
  hidePromoDrawer = false,
  showPromoTimerVariant,
  countdownTimerAvailabileToOrder,
  countdownTimerEnd,
}: Props) => {
  const pageMessages = hidePromoDrawer
    ? promotionalMessages
    : getPromoMessaging(promotionalMessages).pageMessages;

  if (pageMessages.length === 0) return null;

  const scrollToTarget = (e: React.SyntheticEvent) => {
    e.preventDefault();
    const hrefTarget = e.currentTarget.getAttribute("data-href") || "";
    dispatchAccordionOpenEvent(PRODUCT_SPECIAL_OFFERS_ACCORDION_INSTANCE_NAME);
    document
      .querySelector(hrefTarget)
      ?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <div
      data-testid="product:promotional-messages"
      className={styles.promotionalMessagesWrapper}
    >
      {pageMessages
        .slice(0, MAX_PROMO_MESSAGES)
        .map((message: PromotionalMessage | NonPromotionalMessage, idx) => {
          if (message.description) {
            return (
              <button
                className={styles.messageLink}
                data-href="#accordion-special-offers"
                onClick={scrollToTarget}
                key={idx}
              >
                <p className={styles.message}>{message.title}</p>
              </button>
            );
          }
          return (
            <div className={styles.container} key={idx}>
              <p className={styles.message}>{message.title}</p>
              {showPromoTimerVariant?.length > 0 &&
                showPromoTimerVariant !== "C" && (
                  <PromotionalCountdownTimer
                    year={countdownTimerEnd.year}
                    month={countdownTimerEnd.month}
                    day={countdownTimerEnd.day}
                    message={message as PromotionalMessage}
                    availableToOrder={countdownTimerAvailabileToOrder}
                    showPromoTimerVariant={showPromoTimerVariant}
                  />
                )}
            </div>
          );
        })}
    </div>
  );
};
